import React from 'react'
import ReactDOM from 'react-dom'
import { GetMount } from './utils'
import MountProvider from './MountProvider'
import { tealiumBootCallback } from '../tealium'

/**
 * @param {HTMLElement} mountEl
 */
export function MountApplicationToReactDOM (
  mountEl,
  RootComponent,
  MOUNT_DATA,
  MOUNT_KEY
) {
  const mount = GetMount(MOUNT_DATA, MOUNT_KEY)
  const App = (
    <MountProvider mount={mount} mountKey={MOUNT_KEY}>
      <RootComponent />
    </MountProvider>
  )

  ReactDOM.render(
    App,
    mountEl,
    tealiumBootCallback(true, mount.tracking.category, mount.tracking.pagename)
  )
}
